import { useQuery } from '@tanstack/react-query';
import { useCNAllocationApi } from '../../contexts/CNAllocationApiContext';

export const useCNGetRegistryAdminId = () => {
  const { tokenMetadataClient } = useCNAllocationApi();

  return useQuery({
    queryKey: [tokenMetadataClient, 'getCNRegistryInfo'],
    queryFn: () =>
      tokenMetadataClient.getRegistryInfo().then((result) => {
        return result.adminId;
      }),
    refetchInterval: false,
  });
};
